import React, { useState, useEffect } from "react";
import { API_URL } from '../config.js';

const AdminGallery = ({ onLogout }) => {
  const [projects, setProjects] = useState([]);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [images, setImages] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    fetch(`${API_URL}/api/projects`, {
      headers: token ? { "Authorization": "Bearer " + token } : {}
    })
      .then(res => res.json())
      .then(setProjects);
  }, []);

  // Funktion zum Verschieben der Projekte
  const moveProject = async (index, direction) => {
    const newProjects = [...projects];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;
    
    if (targetIndex < 0 || targetIndex >= projects.length) return;
    
    // Projekte tauschen
    [newProjects[index], newProjects[targetIndex]] = [newProjects[targetIndex], newProjects[index]];
    setProjects(newProjects);
    
    // Reihenfolge im Backend speichern
    const token = localStorage.getItem("jwt");
    await fetch(`${API_URL}/api/projects/reorder`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
      },
      body: JSON.stringify({ projects: newProjects })
    });
  };

  const moveToTop = async (index) => {
  if (index === 0) return; // Bereits an erster Stelle
  
  const newProjects = [...projects];
  const projectToMove = newProjects.splice(index, 1)[0]; // Projekt entfernen
  newProjects.unshift(projectToMove); // An den Anfang setzen
  setProjects(newProjects);
  
  // Reihenfolge im Backend speichern
  const token = localStorage.getItem("jwt");
  await fetch(`${API_URL}/api/projects/reorder`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token
    },
    body: JSON.stringify({ projects: newProjects })
  });
};

  const handleImageChange = e => {
    setImageFiles([...e.target.files]);
    Promise.all([...e.target.files].map(file => {
      return new Promise(res => {
        const reader = new FileReader();
        reader.onload = ev => res(ev.target.result);
        reader.readAsDataURL(file);
      });
    })).then(setImages);
  };

  const handleAdd = async e => {
    e.preventDefault();
    if (!title || imageFiles.length === 0) return setMsg("Bitte Titel und mindestens ein Bild angeben.");
    const formData = new FormData();
    
    formData.append("title", title);
    formData.append("description", desc);
    imageFiles.forEach(file => formData.append("images", file));
    const token = localStorage.getItem("jwt");
    const res = await fetch(`${API_URL}/api/projects`, {
      method: "POST",
      headers: {
        "Authorization": "Bearer " + token
      },
      body: formData
    });
    if (res.ok) {
      setMsg("Projekt hinzugefügt!");
      setTitle(""); setDesc(""); setImages([]); setImageFiles([]);
      const token = localStorage.getItem("jwt");
      fetch(`${API_URL}/api/projects`, {
        headers: token ? { "Authorization": "Bearer " + token } : {}
      }).then(res => res.json()).then(setProjects);
    } else {
      setMsg("Fehler beim Hochladen.");
    }
  };

  const handleDelete = async idx => {
    if (!window.confirm("Projekt wirklich löschen?")) return;
    const token = localStorage.getItem("jwt");
    const res = await fetch(`${API_URL}/api/projects/${idx}`, {
      method: "DELETE",
      headers: {
        "Authorization": "Bearer " + token
      }
    });
    if (res.ok) {
      const token = localStorage.getItem("jwt");
      fetch(`${API_URL}/api/projects`, {
        headers: token ? { "Authorization": "Bearer " + token } : {}
      }).then(res => res.json()).then(setProjects);
    }
  };

  const handleLogout = async () => {
    localStorage.removeItem("jwt");
    onLogout();
  };

  return (
    <section style={{maxWidth: 700, margin: "3rem auto", background: "#222", color: "#fff", borderRadius: 18, padding: "2.5rem 1.5rem"}}>
      <h2>Admin: Projekte verwalten</h2>
      <button onClick={handleLogout} style={{float:"right",background:"#444",color:"#fff",border:"none",borderRadius:6,padding:"0.3rem 1rem",cursor:"pointer"}}>Logout</button>
      <button onClick={() => window.location.href = "/admin/settings"} style={{float:"right",background:"#444",color:"#fff",border:"none",borderRadius:6,padding:"0.3rem 1rem",cursor:"pointer",marginRight:8}}>Einstellungen</button>
      <form onSubmit={handleAdd} style={{marginBottom: "2rem", clear: "both"}}>
        <input value={title} onChange={e => setTitle(e.target.value)} placeholder="Titel" style={{width:"100%",marginBottom:8,padding:"0.5rem"}} />
        <textarea value={desc} onChange={e => setDesc(e.target.value)} placeholder="Beschreibung" style={{width:"100%",marginBottom:8,padding:"0.5rem"}} />
        <input type="file" multiple accept="image/*" onChange={handleImageChange} style={{marginBottom:8}} />
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
          {images.map((src,i) => <img key={i} src={src} alt="" style={{width:60,borderRadius:4}} />)}
        </div>
        <button type="submit" style={{background:"#ffa726",color:"#222",fontWeight:"bold",borderRadius:8,padding:"0.7rem 2rem",border:"none",cursor:"pointer"}}>Projekt hinzufügen</button>
        <div style={{color:"#ffa726",marginTop:8}}>{msg}</div>
      </form>
      <h3>Bestehende Projekte (Sortierung mit ↑↓)</h3>
      {projects.map((p,idx) => (
        <div key={idx} style={{background:"#333",borderRadius:8,padding:12,marginBottom:16}}>
          <div style={{display:"flex",alignItems:"flex-start",gap:"1rem"}}>
            {/* Sortier-Buttons */}
            <div style={{display:"flex",flexDirection:"column",gap:"4px"}}>
  {/* NEU: Nach ganz oben Button */}
  <button 
    onClick={() => moveToTop(idx)} 
    disabled={idx === 0}
    style={{
      background: idx === 0 ? "#666" : "#ff9800",
      color:"#fff",
      border:"none",
      borderRadius:4,
      padding:"0.3rem 0.6rem",
      fontSize:"0.8rem",
      cursor: idx === 0 ? "not-allowed" : "pointer",
      opacity: idx === 0 ? 0.5 : 1,
      fontWeight: "bold"
    }}
    title="Nach ganz oben"
  >
    ⬆️
  </button>
  
  {/* Bestehende Up/Down Buttons */}
  <button 
    onClick={() => moveProject(idx, 'up')} 
    disabled={idx === 0}
    style={{
      background: idx === 0 ? "#666" : "#4caf50",
      color:"#fff",
      border:"none",
      borderRadius:4,
      padding:"0.3rem 0.6rem",
      fontSize:"1rem",
      cursor: idx === 0 ? "not-allowed" : "pointer",
      opacity: idx === 0 ? 0.5 : 1
    }}
    title="Einen Platz nach oben"
  >
    ↑
  </button>
  <button 
    onClick={() => moveProject(idx, 'down')} 
    disabled={idx === projects.length - 1}
    style={{
      background: idx === projects.length - 1 ? "#666" : "#4caf50",
      color:"#fff",
      border:"none",
      borderRadius:4,
      padding:"0.3rem 0.6rem",
      fontSize:"1rem",
      cursor: idx === projects.length - 1 ? "not-allowed" : "pointer",
      opacity: idx === projects.length - 1 ? 0.5 : 1
    }}
    title="Einen Platz nach unten"
  >
    ↓
  </button>
</div>

            {/* Projekt-Inhalt */}
            <div style={{flex:1}}>
              <b>{p.title}</b>
              <div>{p.description}</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:8}}>
                {p.images.map((src,i) => <img key={i} src={`${API_URL}${src}`} alt="" style={{width:60,borderRadius:4}} />)}
              </div>
            </div>

            {/* Löschen-Button */}
            <button 
              onClick={() => handleDelete(idx)} 
              style={{background:"#ff5252",color:"#fff",border:"none",borderRadius:6,padding:"0.3rem 1rem",cursor:"pointer"}}
            >
              Löschen
            </button>
          </div>
        </div>
      ))}
    </section>
  );
};

export default AdminGallery;